import {loadStripe} from '@stripe/stripe-js';
import {Elements, ElementsConsumer} from "@stripe/react-stripe-js";
import React from "react";
import {connect} from "react-redux";
import _ from "lodash";
import log from "../util/log";
import api from "../util/api";
import moment from "moment";

export const withStripeElements = (ChildComponent) => {
  class StripeInjectedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        stripePromise : null
      }
    }
    
    componentDidMount() {
      api.Stripe.pubKey()
        .then((res) => {
          let pub_key = _.get(res, 'data.pub_key');
          this.setState({
            stripePromise : pub_key ? loadStripe(pub_key) : null
          })
        })
        .catch((err) => {
          log.error('error getting stripe pub key', err);
        })
    }
  
    render(){
      let {
        i18n
      } = this.props;
      return (
        <Elements stripe={this.state.stripePromise} options={{locale: i18n.language}} key={i18n.language}>
          <ElementsConsumer>
            {({stripe, elements}) => {
              return <ChildComponent {...this.props}
                                     stripe={stripe}
                                     elements={elements}/>;
            }}
          </ElementsConsumer>
        </Elements>
      )
    }
  }
  
  const mapStateToProps = (state) => {
    return {
    }
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
    
    };
  };
  
  return connect(mapStateToProps, mapDispatchToProps)(StripeInjectedComponent);
}
